<template>
  <div class="container">
    <div class="header">
      <div class="user-info" @click="showUserModal = true">
        <div class="avatar"><i class="fas fa-user"></i></div>
        <div class="user-details">
          <div class="user-name">{{ currentUser.name }}</div>
          <div class="user-id">ID: {{ currentUser.id }}</div>
        </div>
      </div>
      <div class="action-buttons">
        <button class="action-btn" @click="showUserModal = true"><i class="fas fa-exchange-alt"></i> 切换登录</button>
        <button class="action-btn" @click="scanQRCode"><i class="fas fa-qrcode"></i> 扫码</button>
      </div>
    </div>

    <div class="menu-container">
      <div class="menu-title"><i class="fas fa-th-large"></i> 功能菜单</div>
      <div class="menu-grid">
        <div class="menu-item" @click="navigateTo('return')">
          <div class="menu-icon"><i class="fas fa-box-open"></i></div>
          <div class="menu-name">回寄采集盒</div>
        </div>
        <div class="menu-item" @click="navigateTo('manage')">
          <div class="menu-icon"><i class="fas fa-users"></i></div>
          <div class="menu-name">储户管理</div>
        </div>
        <div class="menu-item" @click="navigateTo('bill')">
          <div class="menu-icon">
            <i class="fas fa-receipt"></i>
            <span class="badge" v-if="unpaidCount > 0">{{ unpaidCount }}</span>
          </div>
          <div class="menu-name">存储账单</div>
        </div>
        <div class="menu-item" @click="navigateTo('use')">
          <div class="menu-icon"><i class="fas fa-hand-holding-usd"></i></div>
          <div class="menu-name">我要使用</div>
        </div>
        <div class="menu-item" @click="navigateTo('service')">
          <div class="menu-icon"><i class="fas fa-headset"></i></div>
          <div class="menu-name">在线客服</div>
        </div>
        <div class="menu-item" @click="navigateTo('settings')">
          <div class="menu-icon"><i class="fas fa-cog"></i></div>
          <div class="menu-name">设置</div>
        </div>
      </div>

     
    </div>
    下面按钮测试反馈页面
 <div style="display: flex; gap: 10px;">
        <button @click="showFeedback('success')" style="padding: 8px 12px; background: #2ecc71; color: white; border: none; border-radius: 5px; cursor: pointer;">成功</button>
        <button @click="showFeedback('error')" style="padding: 8px 12px; background: #e74c3c; color: white; border: none; border-radius: 5px; cursor: pointer;">错误</button>
        <button @click="showFeedback('warning')" style="padding: 8px 12px; background: #f39c12; color: white; border: none; border-radius: 5px; cursor: pointer;">警告</button>
        <button @click="showFeedback('info')" style="padding: 8px 12px; background: #3498db; color: white; border: none; border-radius: 5px; cursor: pointer;">信息</button>
    </div>
    <!-- 用户选择模态框 -->
    <div class="modal-overlay" v-if="showUserModal" @click.self="showUserModal = false">
      <div class="modal-container">
        <div class="modal-header">
          <div class="modal-title">选择用户</div>
          <button class="modal-close" @click="showUserModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="modal-body">
          <ul class="user-list">
            <li class="user-item" v-for="user in userList" :key="user.id" :class="{active: currentUser.id === user.id}" @click="selectUser(user)">
              <div class="user-item-avatar"><i class="fas fa-user"></i></div>
              <div class="user-item-info">
                <div class="user-item-name">{{ user.name }}</div>
                <div class="user-item-relation">{{ user.relation }}</div>
              </div>
              <div class="user-item-check" v-if="currentUser.id === user.id"><i class="fas fa-check"></i></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mine',
  data () {
    return {
      currentUser: { id: 'AYC20231015001', name: '张小明', relation: '本人' },
      userList: [
        { id: 'AYC20231015001', name: '张小明', relation: '本人' },
        { id: 'AYC20231015002', name: '李小宝', relation: '儿子' },
        { id: 'AYC20231015003', name: '李小贝', relation: '女儿' },
        { id: 'AYC20231015004', name: '李丽', relation: '妻子' },
        { id: 'AYC20231015005', name: '张父', relation: '父亲' }
      ],
      unpaidCount: 2,
      showUserModal: false
    }
  },
  methods: {
    navigateTo (page) {
      this.$router.push(`/${page}`)
    },
    getPageName (page) {
      const map = { return: '回寄采集盒', manage: '储户管理', billing: '存储账单', use: '我要使用', service: '在线客服', settings: '设置' }
      return map[page] || '未知'
    },
    scanQRCode () { this.$router.push('/bind') },
    selectUser (user) {
      this.currentUser = user
      this.showUserModal = false
    },
    showFeedback (type) {
      this.$router.push({ name: 'Result', query: { type } })
    }
  }
}
</script>

<style scoped>
         .container { 
            height: 120%;
            background: #fff; 
            border-radius: 16px; 
            overflow: auto; 
         
            box-shadow: 0 8px 20px rgba(0,0,0,0.08); 
        }
        .header { 
            text-align: center; 
            padding: 30px 20px; 
            background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%); 
            color: white; 
            position: relative;
        }
        .user-info {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            cursor: pointer;
            transition: all 0.3s;
            padding: 10px;
            border-radius: 12px;
        }
        .user-info:hover {
            background: rgba(255,255,255,0.15);
        }
        .avatar {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background: rgba(255,255,255,0.2);
            margin-right: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            border: 2px solid rgba(255,255,255,0.3);
        }
        .user-details {
            text-align: left;
            flex: 1;
        }
        .user-name {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 5px;
        }
        .user-id {
            font-size: 14px;
            opacity: 0.9;
        }
        .action-buttons {
            display: flex;
            justify-content: space-between;
            gap: 10px;
        }
        .action-btn {
            flex: 1;
            background: rgba(255,255,255,0.2);
            border: none;
            border-radius: 10px;
            padding: 12px;
            color: white;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s;
        }
        .action-btn:hover {
            background: rgba(255,255,255,0.3);
            transform: translateY(-2px);
        }
        .action-btn i {
            margin-right: 5px;
        }
        .menu-container {
            padding: 25px 20px;
        }
        .menu-title {
            font-size: 18px;
            color: #3498db;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            padding-left: 5px;
        }
        .menu-title i {
            margin-right: 10px;
            color: #2ecc71;
        }
        .menu-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 15px;
        }
        .menu-item {
            background: #f8f9fa;
            border-radius: 12px;
            padding: 18px 10px;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s;
            border: 1px solid #eee;
        }
        .menu-item:hover {
            background: #e8f4fc;
            transform: translateY(-3px);
            box-shadow: 0 6px 12px rgba(52, 152, 219, 0.15);
        }
        .menu-icon {
            font-size: 26px;
            color: #3498db;
            margin-bottom: 10px;
        }
        .menu-name {
            font-size: 14px;
            color: #555;
            font-weight: 500;
        }
        .badge {
            background: #e74c3c;
            color: white;
            border-radius: 10px;
            padding: 3px 8px;
            font-size: 12px;
            position: absolute;
            top: -5px;
            right: -5px;
        }
        .footer { 
            text-align: center; 
             
            color: #95a5a6; 
            background: #f8f9fa; 
            border-top: 1px solid #eee; 
            font-size: 14px;
        }
         /* 底部导航栏 */
        .tab-bar {
             
            height: 60px;
            background: white;
            display: flex;
            justify-content: space-around;
            align-items: center;
            border-top: 1px solid #eee;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
            z-index: 100;
            max-width: 420px;
            margin: 0 auto;
        }
        .tab-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;
            height: 100%;
            cursor: pointer;
            transition: all 0.3s;
        }
        .tab-item.active {
            color: #3498db;
        }
        .tab-icon {
            font-size: 20px;
            margin-bottom: 4px;
        }
        .tab-name {
            font-size: 12px;
        }
        
        /* 模态框样式 */
        .modal-overlay {
            width:80%;
            margin: 0 auto;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
             
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            animation: fadeIn 0.3s;
        }
        .modal-container {
            background: white;
            border-radius: 16px;
            width: 100%;
            max-width: 400px;
            max-height: 80vh;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
            animation: slideUp 0.4s;
        }
        .modal-header {
            padding: 20px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
            color: white;
        }
        .modal-title {
            font-size: 18px;
            font-weight: 600;
        }
        .modal-close {
            background: none;
            border: none;
            color: white;
            font-size: 22px;
            cursor: pointer;
            padding: 5px;
        }
        .modal-body {
            padding: 0;
            max-height: 60vh;
            overflow-y: auto;
        }
        .user-list {
            list-style: none;
        }
        .user-item {
            display: flex;
            align-items: center;
            padding: 15px 20px;
            border-bottom: 1px solid #f0f0f0;
            cursor: pointer;
            transition: all 0.2s;
            margin-left: -40px;
        }
        .user-item:hover {
            background: #f5f9ff;
        }
        .user-item.active {
            background: #e8f4fc;
        }
        .user-item-avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #e0e0e0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            font-size: 20px;
            color: #777;
        }
        .user-item-info {
            flex: 1;
        }
        .user-item-name {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 4px;
        }
        .user-item-relation {
            font-size: 14px;
            color: #777;
        }
        .user-item-check {
            color: #2ecc71;
            font-size: 20px;
        }
        
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        
        @keyframes slideUp {
            from { 
                opacity: 0;
                transform: translateY(20px);
            }
            to { 
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        /* 响应式设计 */
        @media (max-width: 480px) {
            .container {
                border-radius: 12px;
            }
            .menu-grid {
                grid-template-columns: repeat(2, 1fr);
            }
            .header {
                padding: 25px 15px;
            }
            .menu-container {
                padding: 20px 15px;
            }
        }
</style>
